export default {
    setFilterOption(state, payload) {
        state.filterOption = payload;
    },
    setDayFilter(state, payload) {
        const mapped =  payload.data.fields.feeddateday.map(option => ({
            id: option.text,
            text: option.text 
        }));

        state.dayFilter = mapped;
    },
    setMonthFilter(state, payload) {
        const mapped =  payload.data.fields.feeddatemonth.map(option => ({
            id: option.text,
            text: option.text 
        }));

        state.monthFilter = mapped;
    },
    setLangFilter(state, payload) {
        const mapped =  payload.data.fields.lang.map(option => ({
            id: option.text,
            text: option.text 
        }));

        state.langFilter = mapped;
    },
    setYearFilter(state, payload) {
        const mapped =  payload.data.fields.feeddateyear.map(option => ({
            id: option.text,
            text: option.text 
        }));

        state.yearFilter = mapped;
    },
    setTypeFilter(state, payload) {
        const mapped =  payload.data.fields.feedtype.map(option => ({
            id: option.text,
            text: option.text 
        }));

        state.typeFilter = mapped;
    },
    setKeywordFilter(state, payload) {
        const mapped =  payload.data.fields.keywordtext.map(option => ({
            id: option.text,
            text: option.text 
        }));

        state.keywordFilter = mapped;
    },
    setChannelFilter(state, payload) {
        const mapped =  payload.data.fields.sourcetype.map(option => ({
            id: option.text,
            text: option.text 
        }));

        state.channelFilter = mapped;
    },
    setPublisherFilter(state, payload) {
        const mapped =  payload.data.fields.publishername.map(option => ({
            id: option.text,
            text: option.text 
        }));

        state.publisherFilter = mapped;
    },
    setSentimentFilter(state, payload) {
        const mapped =  payload.data.fields.sentiment.map(option => ({
            id: option.id,
            text: option.text 
        }));

        state.sentimentFilter = mapped;
    },
    setIrrelativeFilter(state, payload) {
        const mapped =  payload.data.fields.irrelative.map(option => ({
            id: option.id,
            text: option.text 
        }));

        state.irrelativeFilter = mapped;
    },
    setSourceFilter(state, payload) {
        const mapped =  payload.data.fields.sourcename.map(option => ({
            id: option.text,
            text: option.text 
        }));

        state.sourceFilter = mapped;
    },
    setMainCatFilter(state, payload) {
        const mapped =  payload.data.fields.opcommentid.map(option => ({
            id: option.id,
            text: option.text,
            parentId: option.parentId
        }));

        state.mainCatFilter = mapped;
    },
    setSubCatFilter(state, payload) {
        const mapped =  payload.data.fields.opstatusid.map(option => ({
            id: option.id,
            text: option.text,
            parentId: option.parentId
        }));

        state.subCatFilter = mapped;
    },
    setDetailCatFilter(state, payload) {
        const mapped =  payload.data.fields.optypeid.map(option => ({
            id: option.id,
            text: option.text,
            parentId: option.parentId 
        }));

        state.detailCatFilter = mapped;
    }
}